import React from 'react';
import LabInfoHelp from './LabInfoHelp';

export default function LabMetric({ label, value, helper, help }) {
  return (
    <div className="lab-metric">
      <div className="lab-metric-label-row">
        <span>{label}</span>
        {help ? <LabInfoHelp compact ariaLabel={help.ariaLabel} {...help} /> : null}
      </div>
      <strong className="lab-metric-value">{value ?? '—'}</strong>
      {helper ? <small>{helper}</small> : null}
    </div>
  );
}
